import FetchGetDataWithAuthNEW from "../services/FetchGetDataWithAuthNEW";

export default function FechGetOneRegularReservationsList(club, idReservation, page) {

  var url = "/reservation/get_club_reservation_regular_list_by_id/" + club + "/" + idReservation + "/" + page;

  return FetchGetDataWithAuthNEW(url);
}

